import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center mb-4" };
const _hoisted_4 = { class: "me-2 fw-medium text-black" };
const _hoisted_5 = { class: "ms-3 d-flex gap-2" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-md-12" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = { class: "col-md-12" };
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_16 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_17 = {
    key: 1,
    class: "badge bg-warning"
};
const _hoisted_18 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_19 = { class: "card-body" };
const _hoisted_20 = { class: "row" };
const _hoisted_21 = { class: "col-md-12 mb-3" };
const _hoisted_22 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_23 = ["placeholder"];
const _hoisted_24 = { class: "col-md-12" };
const _hoisted_25 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_26 = ["disabled"];
const _hoisted_27 = { class: "position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedLanguage) = $event)),
                    options: _ctx.availableLanguages,
                    label: "name",
                    reduce: (lang) => lang.code,
                    class: "language-selector",
                    style: { "min-width": "150px" }
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: lang.code,
                            class: _normalizeClass(["badge",
                                _ctx.isTranslationComplete(lang.code) ? 'bg-success' : 'bg-secondary'
                            ]),
                            style: { "cursor": "pointer" },
                            onClick: ($event) => (_ctx.selectedLanguage = lang.code),
                            title: _ctx.isTranslationComplete(lang.code)
                                ? `${lang.name} - ${_ctx.$t('feature.complete')}`
                                : `${lang.name} - ${_ctx.$t('feature.incomplete')}`
                        }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_6));
                    }), 128))
                ])
            ]),
            _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.saveFeature && _ctx.saveFeature(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.featureData.name) }]),
                                placeholder: _ctx.$t('feature.namePlaceholder'),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.featureData.name) = $event)),
                                onChange: _cache[2] || (_cache[2] = (event) => _ctx.handleInput(event, 'name')),
                                required: ""
                            }, null, 42, _hoisted_11), [
                                [_vModelText, _ctx.featureData.name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('feature.multilingualTranslations')) + " - " + _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                                (_ctx.isTranslationComplete(_ctx.selectedLanguage))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('feature.complete')), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('feature.incomplete')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: _ctx.$t('feature.namePlaceholderLang', { lang: _ctx.getCurrentLanguageName() }),
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                                onBlur: _cache[4] || (_cache[4] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                            }, null, 40, _hoisted_23), [
                                                [_vModelText, _ctx.currentTranslation.name]
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
                    _createElementVNode("div", _hoisted_24, [
                        (_ctx.actionDetected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected === "edit"
                                        ? _ctx.$t('common.update')
                                        : _ctx.$t('feature.addFeature')), 11, _hoisted_26)),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                    class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 32)
        ])
    ]));
}
